import { colors } from './tokens';

/**
 * Static DARK palette - kept for module-scope use (non-React code, navigation
 * theme, StyleSheet constants). Inside components, prefer `useThemePalette()`
 * so colours follow the user's light/dark choice.
 */
export const palette = colors;

export {
  ThemeProvider,
  useTheme,
  useThemePalette,
  type ThemeScheme,
  type Palette,
} from '@/lib/theme/ThemeProvider';

export type FontWeight = 'regular' | 'medium' | 'semibold' | 'bold';

const LATIN_BODY: Record<FontWeight, string> = {
  regular: 'Inter_400Regular',
  medium: 'Inter_500Medium',
  semibold: 'Inter_600SemiBold',
  bold: 'Inter_700Bold',
};

const LATIN_DISPLAY: Record<FontWeight, string> = {
  regular: 'SpaceGrotesk_400Regular',
  medium: 'SpaceGrotesk_500Medium',
  semibold: 'SpaceGrotesk_600SemiBold',
  bold: 'SpaceGrotesk_700Bold',
};

const ARABIC: Record<FontWeight, string> = {
  regular: 'IBMPlexSansArabic_400Regular',
  medium: 'IBMPlexSansArabic_500Medium',
  semibold: 'IBMPlexSansArabic_600SemiBold',
  bold: 'IBMPlexSansArabic_700Bold',
};

/**
 * Resolve a concrete font family. Arabic always uses IBM Plex Sans Arabic
 * (display included - never substitute a Latin face for Arabic glyphs).
 */
export function getFontFamily(
  locale: 'ar' | 'en',
  weight: FontWeight,
  display = false,
): string {
  if (locale === 'ar') return ARABIC[weight];
  return display ? LATIN_DISPLAY[weight] : LATIN_BODY[weight];
}
